
import cmnViewMap from '../Index';
import systemViewMap from '../../system/Index';
import ProdSearchGridHeader from '../../project/production/monitor/components/ProdSearchGridHeader';
import ProdSearchGridProcessHeader from '../../project/production/monitor/components/ProdSearchGridProcessHeader';
import ProdSearchGridProcessData from '../../project/production/monitor/components/ProdSearchGridProcessData';
import DocGridStatView from './components/DocGridStatView';


//Make sure this only contains table columns component
const colViewMap = {
    "vProdSearchGridHeader": ProdSearchGridHeader,
    "vProdSearchGridProcessHeader": ProdSearchGridProcessHeader,
    "vProdSearchGridProcessData": ProdSearchGridProcessData,
    "vCMNSearchXYGridStatsView": DocGridStatView,

    ...cmnViewMap,
    ...systemViewMap
}

export default colViewMap;
